import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailer_notifications-notification_bell-click';

/**
 * Click notification bell on top nav
 */
export function trackRetailerNotificationsNotificationBellClick(
  retailerToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { retailerToken },
  });
}
